import INavigationController from './INavigationController';
import Item from '../../models/Item';
import NavigationApiController from './api/NavigationApiController';
import TestController from '../TestController';
import DisplayItem from '@/models/DisplayItem';
import NavigationContext from './state/NavigationContext';

class AdaptiveNavigationController implements INavigationController {
  private readonly navigationApiController: NavigationApiController;
  private _testController: TestController;
  private currentItem: Item | null = null;

  constructor(navigationApiController: NavigationApiController, testController: TestController) {
    this.navigationApiController = navigationApiController;
    this._testController = testController;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    this.getNextItem().then((item) => {
      //Do nothing.
    });
  }
  isBeginningOfTest(): boolean {
    throw new Error('Method not implemented.');
  }

  getCurrentItem(): Item | null {
    return this.currentItem;
  }

  getNextItem(): Promise<Item | null> {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const that = this;
    return new Promise<Item | null>((resolve, reject) => {
      that.navigationApiController
        .getNextItem(that.currentItem)
        .then((item) => {
          that.currentItem = item;
          that._testController.test = item ? item.section.testPart.test : null;
          resolve(that.currentItem);
        })
        .catch((error) => reject(error));
    });
  }

  get testController(): TestController {
    return this._testController;
  }

  getPreviousItem(): Item | null {
    return null;
  }

  previousAvailable(): boolean {
    return false;
  }

  getItemArray(): Array<Item> {
    const array: Array<Item> = new Array<Item>();
    if (this.currentItem) {
      array.push(this.currentItem);
    }
    return array;
  }

  getAllItems(): Array<DisplayItem> {
    return this.getItemArray();
  }

  getDisplayItems(): Array<Item> {
    return new Array<Item>();
  }

  beginningOfSection(): boolean {
    return false;
  }

  endOfSection(): boolean {
    return false;
  }

  endOfTest(): boolean {
    return false;
  }

  sectionLogout(): boolean {
    return false;
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  setCurrentItem(item: Item): void {
    //Do nothing
  }

  showBackButton(): boolean {
    return false;
  }

  peekNextItem(): DisplayItem | null {
    return null;
  }

  peekPreviousItem(): DisplayItem | null {
    return null;
  }

  lastSectionInTest(): boolean {
    return false;
  }

  set navigationContext(navigationContext: NavigationContext | undefined) {
    throw new Error('Method not implemented.');
  }
  get navigationContext(): NavigationContext | undefined {
    throw new Error('Method not implemented.');
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  setIndex(item: DisplayItem | undefined): void {
    // Do nothing
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  setSectionChangeCallback(callback: () => void) {
    // Do nothing
  }
}

export default AdaptiveNavigationController;
